<ng-content />

@if (sort$ | async; as sort) {
  @if (colName() === sort.field) {
    @switch (sort.dir) {
      @case ("asc") {
        <fu-icon iconName="fu-sort-up" [size]="iconSize()" />
      }
      @case ("desc") {
        <fu-icon iconName="fu-sort-down" [size]="iconSize()" />
      }
    }
  } @else if (withDefaultIcon()) {
    <fu-icon iconName="fu-sort" [size]="iconSize()" />
  }
}
